var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2298_1138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2298_1138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 23.3333C17.667 23.3333 19.0837 22.75 20.2503 21.5833C21.417 20.4167 22.0003 19 22.0003 17.3333C22.0003 15.6667 21.417 14.25 20.2503 13.0833C19.0837 11.9167 17.667 11.3333 16.0003 11.3333C14.3337 11.3333 12.917 11.9167 11.7503 13.0833C10.5837 14.25 10.0003 15.6667 10.0003 17.3333C10.0003 19 10.5837 20.4167 11.7503 21.5833C12.917 22.75 14.3337 23.3333 16.0003 23.3333ZM16.0003 20.6667C15.067 20.6667 14.2781 20.3444 13.6337 19.7C12.9892 19.0556 12.667 18.2667 12.667 17.3333C12.667 16.4 12.9892 15.6111 13.6337 14.9667C14.2781 14.3222 15.067 14 16.0003 14C16.9337 14 17.7225 14.3222 18.367 14.9667C19.0114 15.6111 19.3337 16.4 19.3337 17.3333C19.3337 18.2667 19.0114 19.0556 18.367 19.7C17.7225 20.3444 16.9337 20.6667 16.0003 20.6667ZM5.33366 28C4.60033 28 3.97255 27.7389 3.45033 27.2167C2.9281 26.6944 2.66699 26.0667 2.66699 25.3333V9.33333C2.66699 8.6 2.9281 7.97222 3.45033 7.45C3.97255 6.92778 4.60033 6.66667 5.33366 6.66667H9.53366L12.0003 4H20.0003L22.467 6.66667H26.667C27.4003 6.66667 28.0281 6.92778 28.5503 7.45C29.0725 7.97222 29.3337 8.6 29.3337 9.33333V25.3333C29.3337 26.0667 29.0725 26.6944 28.5503 27.2167C28.0281 27.7389 27.4003 28 26.667 28H5.33366ZM5.33366 25.3333H26.667V9.33333H21.267L18.8337 6.66667H13.167L10.7337 9.33333H5.33366V25.3333Z",
    fill: "#F8F8F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c14e2c168e86430e7d10df9a68a80e66.svg";
export { ForwardRef as ReactComponent };